/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventrequests1Inputs */

const en_eventrequests1 = /** @type {(inputs: Eventrequests1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests`)
};

const de_eventrequests1 = /** @type {(inputs: Eventrequests1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen`)
};

/**
* | output |
* | --- |
* | "Requests" |
*
* @param {Eventrequests1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventrequests1 = /** @type {((inputs?: Eventrequests1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventrequests1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventrequests1(inputs)
	return de_eventrequests1(inputs)
});
export { eventrequests1 as "eventRequests" }